import { colors, Typography } from '@sweep-io/sweep-design';
import { PromptLibraryIcon } from '../PromptLibraryIcon';
import { StyledCard } from './StyledCard';

export const MinimizedPromptCard = ({
  onClick,
  promptGroupId,
  name,
  icon,
}: {
  onClick: (promptGroupId: string) => void;
  promptGroupId: string;
  name: string;
  icon: string;
}) => {
  return (
    <StyledCard
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      onClick={() => onClick(promptGroupId)}
    >
      <PromptLibraryIcon icon={icon} />
      <Typography variant="caption" whiteSpace="nowrap" color={colors.grey[700]}>
        {name}
      </Typography>
    </StyledCard>
  );
};
